import { render, staticRenderFns } from "./GrandPrizePicture.vue?vue&type=template&id=8a4df3e6&scoped=true&"
import script from "./GrandPrizePicture.vue?vue&type=script&lang=js&"
export * from "./GrandPrizePicture.vue?vue&type=script&lang=js&"
import style0 from "./GrandPrizePicture.vue?vue&type=style&index=0&id=8a4df3e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4df3e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a4df3e6')) {
      api.createRecord('8a4df3e6', component.options)
    } else {
      api.reload('8a4df3e6', component.options)
    }
    module.hot.accept("./GrandPrizePicture.vue?vue&type=template&id=8a4df3e6&scoped=true&", function () {
      api.rerender('8a4df3e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/weeklylogin/campaign/components/GrandPrizePicture.vue"
export default component.exports